import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { s__ } from '~/locale';

export function catalogAgentsFromResponse(data) {
  const nodes = data?.aiCatalogConfiguredItems?.nodes || [];
  const invalid = nodes.filter((node) => !node.pinnedItemVersion);

  if (invalid.length > 0) {
    Sentry.captureException(new Error('getConfiguredAgents: nodes with null pinnedItemVersion'), {
      // eslint-disable-next-line @gitlab/require-i18n-strings
      fingerprint: ['{{ default }}', 'workflow-catalog', 'pinned-version-null'],
      extra: {
        affectedConsumers: invalid.map((node) => ({
          consumerId: node.id,
          itemId: node.item?.id,
          pinnedVersionPrefix: node.pinnedVersionPrefix,
        })),
        totalNodes: nodes.length,
      },
    });
  }

  return nodes
    .filter((node) => node.pinnedItemVersion)
    .map((node) => ({ ...node.item, pinnedItemVersionId: node.pinnedItemVersion.id }));
}

export function validateAgentExists(aiCatalogItemVersionId, catalogAgents) {
  // No specific agent selected - using default agent, which is always available
  if (!aiCatalogItemVersionId) {
    return {
      isAvailable: true,
      errorMessage: '',
    };
  }

  // Check if the agent version exists in the catalog
  const agentExists = catalogAgents?.some(
    (agent) => agent.pinnedItemVersionId === aiCatalogItemVersionId,
  );

  if (!agentExists) {
    return {
      isAvailable: false,
      errorMessage: s__(
        'DuoAgenticChat|The agent associated with this conversation is no longer available. You can view the conversation history but cannot send new messages.',
      ),
    };
  }

  return {
    isAvailable: true,
    errorMessage: '',
  };
}

export function prepareAgentSelection(agent, reuseAgent) {
  // Keep current agent when reusing
  if (reuseAgent) {
    return null;
  }

  const newParams = {
    aiCatalogItemVersionId: '',
    selectedFoundationalAgent: null,
    isChatAvailable: true,
    agentDeletedError: '',
  };

  // Select foundational agent
  if (agent?.foundational) {
    return {
      ...newParams,
      agentConfig: null,
      selectedFoundationalAgent: agent,
    };
  }

  // Select custom catalog agent
  if (agent?.id) {
    if (!agent.pinnedItemVersionId) {
      return {
        ...newParams,
        agentConfig: null,
      };
    }
    return {
      ...newParams,
      aiCatalogItemVersionId: agent.pinnedItemVersionId,
    };
  }

  // Reset to default agent
  return {
    ...newParams,
    agentConfig: null,
  };
}
